import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { ReactivateAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/additional-step/additional-info';
import { ReactivateAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/init-step';
import { ReactivateAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/reactivate-asset-due-date-info';

export interface State {
  initStep: ReactivateAssetInitStepV26;
  initAssetServiceStep: AssetSubscriptionV26[];
  deskStep: Desk;
  productStep: DeliveryItemV26;
  dueDatesStep: ReactivateAssetDueDatesV26;
  serviceStep: DeliveryItemV26[];
  addInfoStep: ReactivateAssetAdditionalInfoV26;
  newOrderResponse: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  initAssetServiceStep: null,
  deskStep: null,
  productStep: null,
  dueDatesStep: null,
  serviceStep: null,
  addInfoStep: null,
  newOrderResponse: null,
  errorMessage: null,
};
